import * as Sentry from '@sentry/vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import JWT from './helpers/getJwtToken'
import App from './App.vue'
import router from './router'
import store from './store'
import gettext from './gettext'

const app = createApp(App)
const pinia = createPinia()

app.config.compilerOptions.isCustomElement = tag => ['lottie-player', 'metamap-button'].includes(tag)

const DASHBOARD_URL = process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com'
const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN

Sentry.init({
  app,
  dsn: SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        `${DASHBOARD_URL}/payouts`,
      ],
    }),
    new Sentry.Replay(),
  ],

  // Performance Monitoring
  tracesSampleRate: 0.2, // Capture 20% of the transactions, increase to 1 in development

  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

if (!JWT || !JWT.length) {
  window.location.replace(`${DASHBOARD_URL}/login`)
} else {
  app
    .use(router)
    .use(gettext)
    .use(pinia)
    .use(store)
    .mount('#app');
}
